import React, { useEffect, useState } from "react";

/** Effect 1 — scroll progress bar (purely additive, fixed top). */
export const ScrollProgressBar = () => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const onScroll = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      setPct(max > 0 ? (h.scrollTop / max) * 100 : 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return <div id="rebel-progress" style={{ width: `${pct}%` }} />;
};

/** Effect 4 — scroll-reveal observer. Adds `.in-view` to any `.rebel-reveal`. */
export const ScrollRevealObserver = () => {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("in-view");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    // Initial pass + mutation observer for dynamically rendered elements
    const observeAll = () => {
      document
        .querySelectorAll(".rebel-reveal:not(.in-view)")
        .forEach((el) => io.observe(el));
    };
    observeAll();
    const mo = new MutationObserver(observeAll);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);
  return null;
};

/** Effect 7 — smooth scroll for in-page hash links. */
export const SmoothScrollAnchors = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href === "#") return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector("header");
      const offset = (header?.offsetHeight || 70) + 16;
      window.scrollTo({
        top: target.getBoundingClientRect().top + window.scrollY - offset,
        behavior: "smooth",
      });
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);
  return null;
};

export default ScrollProgressBar;
